import { render } from "./KeywordSearchView.vue?vue&type=template&id=aeffa81e&ts=true"
import script from "./KeywordSearchView.vue?vue&type=script&lang=ts"
export * from "./KeywordSearchView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__